var __decorate = function(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { elementDefine } from "../decorators/index.js";
import { SwcAppMixin } from "./SwcAppMixin.js";
import { createElement } from "../utils/Utils.js";
const swcAppTagName = "swc-app";
const SwcApp = (w, data) => {
  return createElement(w, swcAppTagName, data);
};
const defineSwcApp = async (w) => {
  const existing = w.customElements.get(swcAppTagName);
  if (existing)
    return existing;
  let SwcAppImpl = class SwcAppImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppImpl = __decorate([
    elementDefine(swcAppTagName, { window: w })
  ], SwcAppImpl);
  return w.customElements.whenDefined(swcAppTagName);
};
const swcAppBodyTagName = "swc-app-body";
const SwcAppBody = (w, data) => {
  return createElement(w, swcAppBodyTagName, data);
};
const defineSwcAppBody = async (w) => {
  const existing = w.customElements.get(swcAppBodyTagName);
  if (existing)
    return existing;
  let SwcAppBodyImpl = class SwcAppBodyImpl extends SwcAppMixin(w.HTMLBodyElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppBodyImpl = __decorate([
    elementDefine(swcAppBodyTagName, { window: w, extends: "body" })
  ], SwcAppBodyImpl);
  return w.customElements.whenDefined(swcAppBodyTagName);
};
const swcAppDivTagName = "swc-app-div";
const SwcAppDiv = (w, data) => {
  return createElement(w, swcAppDivTagName, data);
};
const defineSwcAppDiv = async (w) => {
  const existing = w.customElements.get(swcAppDivTagName);
  if (existing)
    return existing;
  let SwcAppDivImpl = class SwcAppDivImpl extends SwcAppMixin(w.HTMLDivElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppDivImpl = __decorate([
    elementDefine(swcAppDivTagName, { window: w, extends: "div" })
  ], SwcAppDivImpl);
  return w.customElements.whenDefined(swcAppDivTagName);
};
const swcAppSectionTagName = "swc-app-section";
const SwcAppSection = (w, data) => {
  return createElement(w, swcAppSectionTagName, data);
};
const defineSwcAppSection = async (w) => {
  const existing = w.customElements.get(swcAppSectionTagName);
  if (existing)
    return existing;
  let SwcAppSectionImpl = class SwcAppSectionImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppSectionImpl = __decorate([
    elementDefine(swcAppSectionTagName, { window: w, extends: "section" })
  ], SwcAppSectionImpl);
  return w.customElements.whenDefined(swcAppSectionTagName);
};
const swcAppMainTagName = "swc-app-main";
const SwcAppMain = (w, data) => {
  return createElement(w, swcAppMainTagName, data);
};
const defineSwcAppMain = async (w) => {
  const existing = w.customElements.get(swcAppMainTagName);
  if (existing)
    return existing;
  let SwcAppMainImpl = class SwcAppMainImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppMainImpl = __decorate([
    elementDefine(swcAppMainTagName, { window: w, extends: "main" })
  ], SwcAppMainImpl);
  return w.customElements.whenDefined(swcAppMainTagName);
};
const swcAppArticleTagName = "swc-app-article";
const SwcAppArticle = (w, data) => {
  return createElement(w, swcAppArticleTagName, data);
};
const defineSwcAppArticle = async (w) => {
  const existing = w.customElements.get(swcAppArticleTagName);
  if (existing)
    return existing;
  let SwcAppArticleImpl = class SwcAppArticleImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppArticleImpl = __decorate([
    elementDefine(swcAppArticleTagName, { window: w, extends: "article" })
  ], SwcAppArticleImpl);
  return w.customElements.whenDefined(swcAppArticleTagName);
};
const swcAppHeaderTagName = "swc-app-header";
const SwcAppHeader = (w, data) => {
  return createElement(w, swcAppHeaderTagName, data);
};
const defineSwcAppHeader = async (w) => {
  const existing = w.customElements.get(swcAppHeaderTagName);
  if (existing)
    return existing;
  let SwcAppHeaderImpl = class SwcAppHeaderImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppHeaderImpl = __decorate([
    elementDefine(swcAppHeaderTagName, { window: w, extends: "header" })
  ], SwcAppHeaderImpl);
  return w.customElements.whenDefined(swcAppHeaderTagName);
};
const swcAppFooterTagName = "swc-app-footer";
const SwcAppFooter = (w, data) => {
  return createElement(w, swcAppFooterTagName, data);
};
const defineSwcAppFooter = async (w) => {
  const existing = w.customElements.get(swcAppFooterTagName);
  if (existing)
    return existing;
  let SwcAppFooterImpl = class SwcAppFooterImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppFooterImpl = __decorate([
    elementDefine(swcAppFooterTagName, { window: w, extends: "footer" })
  ], SwcAppFooterImpl);
  return w.customElements.whenDefined(swcAppFooterTagName);
};
const swcAppNavTagName = "swc-app-nav";
const SwcAppNav = (w, data) => {
  return createElement(w, swcAppNavTagName, data);
};
const defineSwcAppNav = async (w) => {
  const existing = w.customElements.get(swcAppNavTagName);
  if (existing)
    return existing;
  let SwcAppNavImpl = class SwcAppNavImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppNavImpl = __decorate([
    elementDefine(swcAppNavTagName, { window: w, extends: "nav" })
  ], SwcAppNavImpl);
  return w.customElements.whenDefined(swcAppNavTagName);
};
const swcAppAsideTagName = "swc-app-aside";
const SwcAppAside = (w, data) => {
  return createElement(w, swcAppAsideTagName, data);
};
const defineSwcAppAside = async (w) => {
  const existing = w.customElements.get(swcAppAsideTagName);
  if (existing)
    return existing;
  let SwcAppAsideImpl = class SwcAppAsideImpl extends SwcAppMixin(w.HTMLElement) {
    // SwcAppMixin에서 모든 기능을 상속받음. 기본 요소라 훅에서 할 일은 없음.
    onConnected() {
    }
    onDisconnected() {
    }
    onSwcAppConnected() {
    }
  };
  SwcAppAsideImpl = __decorate([
    elementDefine(swcAppAsideTagName, { window: w, extends: "aside" })
  ], SwcAppAsideImpl);
  return w.customElements.whenDefined(swcAppAsideTagName);
};
const swcAppFactories = [
  defineSwcApp,
  defineSwcAppBody,
  defineSwcAppDiv,
  defineSwcAppSection,
  defineSwcAppMain,
  defineSwcAppArticle,
  defineSwcAppHeader,
  defineSwcAppFooter,
  defineSwcAppNav,
  defineSwcAppAside
];
const defineSwcAppAll = async (w) => {
  await Promise.all(swcAppFactories.map((factory) => factory(w)));
  return w.customElements.whenDefined(swcAppTagName);
};
var SwcApp_default = defineSwcAppAll;
export {
  SwcApp,
  SwcAppArticle,
  SwcAppAside,
  SwcAppBody,
  SwcAppDiv,
  SwcAppFooter,
  SwcAppHeader,
  SwcAppMain,
  SwcAppNav,
  SwcAppSection,
  SwcApp_default as default,
  defineSwcApp,
  defineSwcAppAll,
  defineSwcAppArticle,
  defineSwcAppAside,
  defineSwcAppBody,
  defineSwcAppDiv,
  defineSwcAppFooter,
  defineSwcAppHeader,
  defineSwcAppMain,
  defineSwcAppNav,
  defineSwcAppSection,
  swcAppArticleTagName,
  swcAppAsideTagName,
  swcAppBodyTagName,
  swcAppDivTagName,
  swcAppFactories,
  swcAppFooterTagName,
  swcAppHeaderTagName,
  swcAppMainTagName,
  swcAppNavTagName,
  swcAppSectionTagName,
  swcAppTagName
};
//# sourceMappingURL=SwcApp.js.map
